export default "__VITE_ASSET__BLl5rdTW__"